import { createAction, props } from '@ngrx/store'

const SOURCE = '[Main View]'
export const setAllIsEditingFalse = createAction(`${ SOURCE } SetAllIsEditingFalse`)

export const resetNotifications = createAction(`${ SOURCE } resetNotifications`)

export const resetNotificationsRead = createAction(`${ SOURCE } resetNotificationsRead`)

export const resetUnreadNotificationsCount = createAction(`${ SOURCE } resetUnreadNotificationsCount`)

export const resetReadNotificationsCount = createAction(`${ SOURCE } resetReadNotificationsCount`)

export const resetBulkOperations = createAction(`${ SOURCE } resetBulkOperations`)

export const resetExistContractBulkOperation = createAction(`${ SOURCE } resetExistContractBulkOperation`)

export const updateImportantMessages = createAction(
    `${ SOURCE } updateImportantMessages`,
    props<{messages: any[]}>()
)

export const setUnreadNotificationsCount = createAction(
    `${ SOURCE } setUnreadNotificationsCount`,
    props<{count: number}>()
)

export const setUnreadNotificationsCountInternal = createAction(
    `${ SOURCE } setUnreadNotificationsCountInternal`,
    props<{count: number}>()
)

export const setReadNotificationsCount = createAction(
    `${ SOURCE } setReadNotificationsCount`,
    props<{count: number}>()
)

export const setBlockRequests = createAction(
    `${ SOURCE } setBlockRequests`,
    props<{blockRequests: any}>()
)

export const setExistContractBulkOperation = createAction(
    `${ SOURCE } setExistContractBulkOperation`,
    props<{existContractBulkOperation: boolean}>()
)

export const setCuzkPasswordValidityState = createAction(
    `${ SOURCE } setCuzkPasswordValidityState`,
    props<{cuzkPasswordValidityState: any}>()
)

export const setSkippedDateDueCuzkPasswordValidity = createAction(
    `${ SOURCE } setSkippedDateDueCuzkPasswordValidity`,
    props<{skippedDateDueCuzkPasswordValidity: any}>()
)

export const setBreadcrumbs = createAction(
    `${ SOURCE } setBreadcrumbs`,
    props<{breadcrumbs: any}>()
)

export const resetBreadcrumbs = createAction(
    `${ SOURCE } resetBreadcrumbs`
)

export const runBulkOperationUpdate = createAction(
    `${ SOURCE } runBulkOperationUpdate`
)

export const toggleShowBulkOperations = createAction(
    `${ SOURCE } toggleShowBulkOperations`
)

export const toggleShowBulkOperationsOff = createAction(
    `${ SOURCE } toggleShowBulkOperationsOff`
)

export const setNotificationDetail = createAction(
    `${ SOURCE } setNotificationDetail`,
    props<{detail: any}>()
)
export const setNotificationDetailInternal = createAction(
    `${ SOURCE } setNotificationDetailInternal`,
    props<{detail: any}>()
)


export const resetNotificationDetail = createAction(
    `${ SOURCE } resetNotificationDetail`
)

export const setImportantMessages = createAction(
    `${ SOURCE } setImportantMessages`,
    props<{messages: any[]}>()
)

export const setNotifications = createAction(
    `${ SOURCE } setNotifications`,
    props<{notifications: any[]}>()
)

export const setNotificationsRead = createAction(
    `${ SOURCE } setNotificationsRead`,
    props<{notifications: any[]}>()
)

export const setDepartments = createAction(
    `${ SOURCE } setDepartments`,
    props<{departments: any[]}>()
)

export const resetDepartments = createAction(
    `${ SOURCE } resetDepartments`
)

export const setSelectedDepartment = createAction(
    `${ SOURCE } setSelectedDepartment`,
    props<{department: any}>()
)

export const setSelectedDepartmentInternal = createAction(
    `${ SOURCE } setSelectedDepartmentInternal`,
    props<{department: any}>()
)

export const setContractBulkOperationLoading = createAction(
    `${ SOURCE } setContractBulkOperationLoading`,
    props<{loading: boolean}>()
)

export const setBulkOperations = createAction(
    `${ SOURCE } setBulkOperations`,
    props<{bulkOperations: any[]}>()
)

export const setShowBulkOperations = createAction(
    `${ SOURCE } setShowBulkOperations`,
    props<{showBulkOperations: boolean}>()
)

export const setBulkOperationUpdate = createAction(
    `${ SOURCE } setBulkOperationUpdate`,
    props<{bulkOperationUpdate: any}>()
)

export const resetSelectedDepartment = createAction(
    `${ SOURCE } resetSelectedDepartment`
)

export const noAction = createAction(
    `${ SOURCE } noAction`
)
